<!--
Colorepaper
色纸
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="色纸" name="色纸">
        <el-row>
          <el-col :span="24">
            <el-form :label-position="labelPosition" :model="colorepaper" label-width="80px">
              <el-form-item label="包边颜色">
                <el-radio-group v-model="colorepaper['包边颜色']">
                  <el-radio-button label="金色">金色</el-radio-button>
                  <el-radio-button label="银色">银色</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="印刷纸张">
                <el-radio-group v-model="colorepaper['印刷纸张']">
                  <el-radio-button label="铜版纸">铜版纸</el-radio-button>
                  <el-radio-button label="亚粉纸">亚粉纸</el-radio-button>
                  <el-radio-button label="超感纸">超感纸</el-radio-button>
                  <el-radio-button label="其他">其他</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="覆膜">
                <el-radio-group v-model="colorepaper['覆膜']">
                  <el-radio-button label="亮膜">亮膜</el-radio-button>
                  <el-radio-button label="亚膜">亚膜</el-radio-button>
                  <el-radio-button label="不覆膜">不覆膜</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="特殊工艺">
                <el-radio-group v-model="colorepaper['工艺']">
                  <el-radio-button label="烫金">烫金</el-radio-button>
                  <el-radio-button label="烫银">烫银</el-radio-button>
                  <el-radio-button label="镭射银">镭射银</el-radio-button>
                </el-radio-group>
                <el-alert
                  title="其他工艺请联系客服"
                  type="info"
                  show-icon
                  class="el-alert__title"
                  style="padding: 8px 16px; margin: 20px 0 0 0;"
                ></el-alert>
              </el-form-item>
              <el-form-item label="尺寸">
                <el-row type="flex" class="row-bg">
                  <el-col :span="12">
                    <el-input v-model="colorepaper['尺寸宽']" placeholder="宽 cm"></el-input>
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <el-input v-model="colorepaper['尺寸长']" placeholder="长 cm"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="款式">
                <el-input v-model="colorepaper['款式']" placeholder="请填写您选择的款式"></el-input>
              </el-form-item>
              <el-form-item label="数量" :inline="true">
                <el-input-number v-model="colorepaper['数量']" :min="1" label="数量"></el-input-number>
              </el-form-item>
              <el-button v-on:click="addEvent()">提交</el-button>
              <el-button v-on:click="clear()">清空</el-button>
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "Colorepaper",
  data() {
    return {
      forcollapse: ["allsame"],
      colorepaper: {
        title: "色纸",
        工艺: []
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.colorepaper);
    },
    clear() {
      this.$root.clearAlert();
      this.colorepaper = {
        title: "色纸",
        工艺: []
      };
    }
  }
};
</script>
<style scoped>
</style>